import { auth } from "@/config/firebase";

function sendVerificationMail() {
  auth.currentUser.sendEmailVerification();
}

export default sendVerificationMail;
